/**
 * Any template agent's definition by its agent type: a built-in one from
 * AGENT_DEFINITIONS, or a custom one from workspace_custom_agents. Null while
 * a custom agent loads or when the agent type is unknown.
 */

import { useEffect, useMemo } from 'react';
import { getAgentDefinition, definitionForCustomAgent, isCustomAgentType, type AgentDefinition } from '../lib/ai/agentDefinitions';
import { useCustomAgentStore } from '../stores/prioritization/customAgentStore';

export function useAgentDefinition(agentType: string | undefined): { def: AgentDefinition | null; loading: boolean } {
  const customId = isCustomAgentType(agentType) ? agentType!.slice('custom_'.length) : null;
  const custom = useCustomAgentStore((s) => (customId ? s.agents.find((a) => a.id === customId) ?? null : null));
  const fetchAgent = useCustomAgentStore((s) => s.fetchAgent);
  useEffect(() => {
    if (customId && !custom) void fetchAgent(customId);
  }, [customId, custom, fetchAgent]);
  const def = useMemo(
    () => (customId ? (custom ? definitionForCustomAgent(custom) : null) : (agentType ? getAgentDefinition(agentType) ?? null : null)),
    [customId, custom, agentType],
  );
  return { def, loading: !!customId && !custom };
}
